module.exports = __webpack_public_path__ + "img/arrow_back_gray.1a8dc767.svg";